<div class="example-container">
  <div class="background-panel" (click)="closeSideBar()" [ngStyle]="{display: opened ? 'inline' : 'none'}"></div>
  <div mode="side" class="sidebar-container" [ngStyle]="{right: opened ? 0 : sidebarInPos}">
    <a (click)="closeSideBar()"><h3 class="sidebar-container__header"><i class='material-icons'>
      navigate_before
    </i>Account Settings</h3></a>
    <hr>
    <nav mat-tab-nav-bar class="sidebar-tabs-bar">
      <a *ngIf="showProfileTab" mat-tab-link [routerLink]="['', { outlets: { 'sidebar': ['profile'] }}]" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive" [routerLinkActiveOptions]="{exact:true}" disableRipple>
        Profile
      </a>
      <a *ngIf="showTaxDetailsTab$ | async" mat-tab-link [routerLink]="['', { outlets: { 'sidebar': ['profile', 'taxDetails'] }}]" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive" [routerLinkActiveOptions]="{exact:true}" disableRipple>
        Tax Details
      </a>
      <a mat-tab-link [routerLink]="['', { outlets: { 'sidebar': ['profile', 'changeTFA'] }}]" routerLinkActive #rla="routerLinkActive" [routerLinkActiveOptions]="{exact:true}" [active]="rla.isActive" disableRipple>
        Password
      </a>
      <a *ngIf="showInvitations" mat-tab-link [routerLink]="['', { outlets: { 'sidebar': ['profile', 'invitations'] }}]" routerLinkActive #rla="routerLinkActive" [routerLinkActiveOptions]="{exact:true}" [active]="rla.isActive" disableRipple>
        Invitations
      </a>
      <a *ngIf="showBankAccounts" mat-tab-link [routerLink]="['', { outlets: { 'sidebar': ['profile', 'bankAccounts'] }}]" routerLinkActive #rla="routerLinkActive" [routerLinkActiveOptions]="{exact:true}" [active]="rla.isActive" disableRipple>
        Bank Accounts
      </a>
    </nav>
    <div class="sidebar-tabs-ruler"></div>
    <router-outlet></router-outlet>
  </div>
</div>
